import React, { useEffect, useState } from "react";
import styles from './TagContainer.module.css';
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../functions/Functions";
import ImgComponent from "../../elements/imgComponent/ImgComponent";

export default function TagContainer({tag,imgArray,small}){

    const [tagImgs,setTagImgs] = useState(imgArray);
    const [randImg,setRandImg] = useState(imgArray[Math.floor(Math.random()*imgArray.length)]);

    const [loadedA,setLoadedA] = useState(false);
    const [loadedB,setLoadedB] = useState(false);

    useEffect(() => {
        setTagImgs(() => {
            const newArray = imgArray.filter((imgObj) => imgObj.tags.some((arrTag) => arrTag === tag));
            if(newArray.length > 0){
                setRandImg(newArray[Math.floor(Math.random()*newArray.length)])
            }
            return newArray;
        });
    },[imgArray]);

    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/gallery/${tag}`)
    }

   
    if(small){
        return(
            <div key={`smallCon${tag}`} className={`${styles.tagContainer} ${styles.small}`} onClick={handleClick}>
                <div className={styles.overlay}>
                    <p>{capitalizeFirstLetter(tag)}</p>
                </div>
                <div className={styles.imgContainer}>
                    <ImgComponent imgObject={randImg} maxSize="px1000"/>
                </div>
            </div>
        )
    } else {
        return(
            <div key={`largeCon${tag}`} className={`${styles.tagContainer}`} onClick={handleClick}>
                <div className={styles.imgContainer}>
                    <ImgComponent imgObject={randImg} maxSize="px1000"/>
                </div>
                <div className={styles.overlay}>
                    <h2>{capitalizeFirstLetter(tag)}</h2>
                </div>
                
            </div>
        )
    }
}